import * as React from "react";
import cx from "classnames";

import styles from "./save-button.module.css";

interface IProps {
  className?: string;
  children: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
}

export default function SaveButton({
  children,
  className,
  type,
  onClick
}: IProps) {
  return (
    <button
      type={type}
      className={cx(styles.button, className)}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
